/** Dashboard nudge to create an account, shown once after real progress exists. */

import { el } from '../utils/dom.js';
import { icon } from '../utils/icons.js';
import { button } from './ui.js';
import { readJSON, writeJSON } from '../utils/storage.js';
import { isSupabaseConfigured } from '../lib/supabaseClient.js';
import { navigate } from '../app/router.js';

const DISMISS_KEY = 'quantmaster:v1:account-nudge-dismissed';

export function isAccountNudgeDismissed() {
  return Boolean(readJSON(DISMISS_KEY, false));
}

export function dismissAccountNudge() {
  writeJSON(DISMISS_KEY, true);
}

/** Shown once, after the learner has actually completed a session and isn't signed in. */
export function accountNudgeCard() {
  if (!isSupabaseConfigured() || isAccountNudgeDismissed()) return null;

  const card = el('div.card.card--accent', {}, [
    el('div.row', { style: { alignItems: 'flex-start' } }, [
      el('div.action-tile__icon', {}, [icon('sparkles', { size: 20 })]),
      el('div', { style: { flex: 1, minWidth: 0 } }, [
        el('div.card__title', { text: 'Keep this progress if you switch devices' }),
        el('p.card__sub', {
          text: 'A free account syncs your mastery, XP and streak — never the exact questions you were asked.'
        })
      ])
    ]),
    el('div.row.row--wrap', { style: { marginTop: '12px', gap: '8px' } }, [
      button('Create account', {
        variant: 'primary',
        size: 'sm',
        iconName: 'sparkles',
        onClick: () => {
          dismissAccountNudge();
          card.remove();
          navigate('/settings');
        }
      }),
      button('Not now', {
        variant: 'ghost',
        size: 'sm',
        onClick: () => {
          dismissAccountNudge();
          card.remove();
        }
      })
    ])
  ]);
  return card;
}
